namespace Matrix.Dashboards {
    export interface DatasetForm {
        DatasetCode: Serenity.StringEditor;
        Name: Serenity.StringEditor;
        Permission: Serenity.StringEditor;
        DatasetType: Serenity.LookupEditor;
        ParameterList: Data.DataParameterListEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class DatasetForm extends Serenity.PrefixedContext {
        static formKey = 'Dashboards.Dataset';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!DatasetForm.init)  {
                DatasetForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = Data.DataParameterListEditor;
                var w3 = StaticTextBlock;
                var w4 = ReadOnlyDateTime;

                Q.initFormType(DatasetForm, [
                    'DatasetCode', w0,
                    'Name', w0,
                    'Permission', w0,
                    'DatasetType', w1,
                    'ParameterList', w2,
                    'CreatedBy', w3,
                    'CreatedWhen', w4,
                    'UpdatedBy', w3,
                    'UpdatedWhen', w4,
                    'Version', w3
                ]);
            }
        }
    }
}
